import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { QueryKey } from '@/api/common/types/query-key.enum';
import { useAppToasts } from '@/hooks/use-app-toasts';
import type { GroupInvitationResponsePayload } from '@/api/group/types/group-invitation-response-payload';
import { groupInviteResponse } from '@/api/group/group.api';
import type { Group } from '@/api/group/types/group';
import { refreshStateAfterGroupInviteResponse } from '@/api/group/utils/refresh-after-group-invite';
import { useUser } from '@/api/user/queries/use-user';

export const useGroupInvitationResponse = () => {
  const { data: user } = useUser();
  const { raiseErrorToast } = useAppToasts();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: GroupInvitationResponsePayload) => groupInviteResponse(payload),
    onMutate: async ({ groupId, status }: GroupInvitationResponsePayload) => {
      await queryClient.cancelQueries({ queryKey: [QueryKey.GetGroups] });
      // await queryClient.cancelQueries({ queryKey: [QueryKey.GetGroup, groupId] });

      const previousGroups = queryClient.getQueryData<Group[]>([QueryKey.GetGroups]);
      // const previousGroup = queryClient.getQueryData<Group>([QueryKey.GetGroup, groupId]);
      const member = previousGroups
        ?.find(group => group.id === groupId)
        ?.members.find(member => member.id === user.value?.id);
      if (!member) return { previousGroups }; //, previousGroup };

      const memberToUpdate = {
        ...member,
        inviteStatus: status,
      };

      queryClient.setQueryData<Group[]>([QueryKey.GetGroups], oldGroups => {
        if (!oldGroups?.length) return [];
        return oldGroups.map(group => {
          if (group.id === groupId) {
            const members = group.members.map(m => (m.id === memberToUpdate.id ? memberToUpdate : m));
            return {
              ...group,
              members,
            };
          }
          return group;
        });
      });

      // if (previousGroup) {
      //   const members = previousGroup.members.map(m => (m.id === memberToUpdate.id ? memberToUpdate : m));
      //   queryClient.setQueryData<Group>([QueryKey.GetGroup, groupId], { ...previousGroup, members });
      // }

      return { previousGroups }; //, previousGroup };
    },
    onError: (err, groupId, context) => {
      raiseErrorToast();
      queryClient.setQueryData([QueryKey.GetGroups], context?.previousGroups);
      // queryClient.setQueryData([QueryKey.GetGroup, groupId], context?.previousGroup);
    },
    onSuccess: (_data, { groupId }) => {
      void refreshStateAfterGroupInviteResponse(queryClient, groupId);
    },
  });
};
